import { ButtonLink } from "../components/Button";
import {
  SubtitleWrapper,
  TextShadeWrapper,
  TitleWrapper,
} from "../components/Wrappers";
import ReactPlayer from "react-player";
import { AMAZON_STORE_LINK, YOUTUBE_LINK } from "../constants";

const Productivity = () => {
  return (
    <div className="productivity">
      <div className="productivity__container">
        <div className="productivity__content">
          <TitleWrapper
            lineHeight="49px"
            textAlignMd="center"
            textAlignSm="left"
          >
            A short video about{" "}
            <TextShadeWrapper>Blockchain Banking</TextShadeWrapper>{" "}
          </TitleWrapper>
          <SubtitleWrapper
            lineHeight="30px"
            marginTop="12px"
            marginBottom="32px"
          >
            Understanding the Basics of Blockchain Technology and Its Impact on
            Banking.
          </SubtitleWrapper>
          <ButtonLink primaryBtn href={AMAZON_STORE_LINK} widthSm="100%">
            Get your Copy
          </ButtonLink>
        </div>
        <div className="productivity__video">
          <ReactPlayer
            url={YOUTUBE_LINK}
            controls={true}
            width="100%"
            height="100%"
          />
        </div>
        {/* <img
          className="productivity__video__pattern"
          src={ProductivityVideoBg}
          alt="pattern"
        /> */}
      </div>
    </div>
  );
};

export default Productivity;
